function buildAlohasCarousel(carousel, scrollContainer) {
    const rightArrow = carousel.querySelector('.alohas--arrow-right')
    const leftArrow = carousel.querySelector('.alohas--arrow-left')
  
    const updateArrowsState = () => {
        if (scrollContainer.scrollLeft <= 0) {
          leftArrow.classList.add('disabled');
        } else {
          leftArrow.classList.remove('disabled');
        }
  
        if (scrollContainer.scrollLeft + scrollContainer.offsetWidth >= scrollContainer.scrollWidth) {
          rightArrow.classList.add('disabled');
        } else {
          rightArrow.classList.remove('disabled');
        }
      };
  
    const scrollSlider = (direction) => {
      let scrollAmount;
      
      if (scrollContainer.getAttribute('data-benefits-slider') !== null) {
        scrollAmount = direction === 'right' ? 520 : -520;
      } else if (scrollContainer.getAttribute('data-level-benefits-slider') !== null) {
        scrollAmount = direction === 'right' ? 520 : -520;
      } else {
        scrollAmount = direction === 'right' ? 327 : -327;
      }
      
      scrollContainer.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    };
    rightArrow.addEventListener('click', () => scrollSlider('right'));
    leftArrow.addEventListener('click', () => scrollSlider('left'));
  
    scrollContainer.addEventListener('scroll', updateArrowsState);
  }